<template>
    <div>
      <div class="row" v-if="value">
        <div class="col-md-12">
          <fg-input :placeholder="'Title' | translate" :label="'Title' | translate" v-model="value.title"></fg-input>
        </div>
      </div>
      <el-table :data="schemaTable" style="width: 100%" ref="schemaTable" row-key="key" :expand-row-keys="expandedRows">
        <el-table-column type="expand">
          <template slot-scope="props">
            <div class="row">
              <label class="col-md-3 col-form-label" v-translate>Field type</label>
              <div class="col-md-9">
                <el-select class="select-info"
                           :placeholder="'Select field type' | translate"
                           v-model="props.row.type">
                  <el-option v-for="option in fieldTypes"
                             class="select-info"
                             :value="option.value"
                             :label="option.label"
                             :key="option.label">
                  </el-option>
                </el-select>
              </div>

              <label class="col-md-3 col-form-label" v-translate>Title</label>
              <div class="col-md-9">
                <fg-input :placeholder="'Title' | translate" v-model="props.row.title"></fg-input>
              </div>

              <label class="col-md-3 col-form-label" v-translate>Field key</label>
              <div class="col-md-9">
                <fg-input :placeholder="'Field key' | translate" v-model="props.row.fieldName"></fg-input>
              </div>

              <label class="col-md-3 col-form-label" v-translate>Placeholder</label>
              <div class="col-md-9">
                <fg-input :placeholder="'Placeholder' | translate" v-model="props.row.placeholder"></fg-input>
              </div>

              <label class="col-md-3 col-form-label" v-translate>Message on error</label>
              <div class="col-md-9">
                <fg-input :placeholder="'Message on error' | translate" v-model="props.row.messageOnError"></fg-input>
              </div>

              <label class="col-md-3 col-form-label" v-translate>Autocapitalize</label>
              <div class="col-md-9">
                <el-select class="select-info"
                           :placeholder="'Select field type' | translate"
                           v-model="props.row.autocapitalize">
                  <el-option v-for="option in autocapitalizeTypes"
                             class="select-info"
                             :value="option.value"
                             :label="option.label"
                             :key="option.label">
                  </el-option>
                </el-select>
              </div>

              <label class="col-md-3 col-form-label" v-translate>Load value from field</label>
              <div class="col-md-9">
                <fg-input :placeholder="'Load value from field' | translate" v-model="props.row.initialFrom"></fg-input>
              </div>

              <label class="col-md-3 control-label" v-translate v-if="!props.row.visible">Visible rule</label>
              <div class="col-md-9">
                <MonacoEditor v-if="!props.row.visible"
                              ref="jsonEditor"
                              v-model="props.row.visibleIf"
                              theme="vs-dark"
                              language="javascript"
                              height="80"
                              :options="visibleRuleEditorOptions"
                ></MonacoEditor>
              </div>

            </div>
            <div class="row" v-if="showChoices(props.row) && props.row.choices">
              <div class="col-md-12">
                <answer-choices :value="props.row.choices"></answer-choices>
              </div>
            </div>
            <!--            <p>{{ props.row.options }}</p>-->
            <!--            <pre>{{ props.row.choices }}</pre>-->
          </template>
        </el-table-column>
        <el-table-column :label="'Name' | translate">
          <template slot-scope="props">
            <p>{{ props.row.title || props.row.fieldName }}<span v-if="props.row.required"> *</span></p>
          </template>
        </el-table-column>
        <el-table-column
          prop="fieldName"
          :label="'Field name' | translate"
          width="180">
          <template slot-scope="props">
            <fg-input :placeholder="'Field key' | translate" v-model="props.row.fieldName"></fg-input>
          </template>
        </el-table-column>
        <el-table-column
          :label="'Required' | translate"
          width="180">
          <template slot-scope="props">
            <p-switch v-model="props.row.required" color="black"></p-switch>
          </template>
        </el-table-column>
        <el-table-column
          :label="'Visible' | translate"
          width="180">
          <template slot-scope="props">
            <p-switch v-model="props.row.visible" color="black"></p-switch>
          </template>
        </el-table-column>
        <el-table-column>
          <template slot-scope="props">
            <el-tooltip :content="'Delete' | translate" placement="top">
              <p-button v-if="!autoSchema" type="danger" size="sm" icon @click="(e) => handleDelete(e, props.$index, props.row)">
                <i class="fa fa-times"></i>
              </p-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <el-tooltip :content="'Add field' | translate" placement="top">
        <p-button type="success" size="sm" icon @click="(e) => addField()">
          <i class="fa fa-plus"></i>
        </p-button>
      </el-tooltip>
    </div>
</template>

<script>
  import {Table, TableColumn, Select, Option, Tooltip} from 'element-ui'
  import {Switch, Card, Button} from 'src/components/UIComponents'
  import {SortableTable} from 'src/components/Expostat/Components'
  import MonacoEditor from 'monaco-editor-vue';
  import AnswerChoices from './AnswerChoices'


  export default {
    components: {
      Button,
      Card,
      SortableTable,
      [Tooltip.name]: Tooltip,
      [Switch.name]: Switch,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Select.name]: Select,
      [Option.name]: Option,
      MonacoEditor,
      AnswerChoices
    },
    name: 'SchemaEditor',
    props: {
      value: !Object,
      autoSchema: {
        type: Boolean,
        default () {
          return false
        }
      }
    },

    computed: {
      schemaTable () {
        if (this.value !== null) {
          return this.getSchemaTable(this.value)
        } else {
          return []
        }
      },
    },
    data () {
      return {
        visibleRuleEditorOptions: {
          autoIndent: true
        },

        expandedRows: [],

        // Справочники
        fieldTypes: [
          {value: 'text', label: this.$gettext('Text string')},
          {value: 'phone', label: this.$gettext('Phone')},
          {value: 'date', label: this.$gettext('Date')},
          {value: 'email', label: this.$gettext('E-mail')},
          {value: 'checkboxgroup', label: this.$gettext('Checkbox group')},
          {value: 'radiogroup', label: this.$gettext('Radio group')},
          {value: 'checkbox', label: this.$gettext('Checkbox')},
          {value: 'select', label: this.$gettext('Select')},
          {value: 'switch', label: this.$gettext('Switch')}
        ],
        autocapitalizeTypes: [
          {value: false, label: this.$gettext('Disabled')},
          {value: 'words', label: this.$gettext('By words')},
          {value: 'sentences', label: this.$gettext('By sentences')},
          {value: 'characters', label: this.$gettext('CAPS LOCK')}
        ]

      }
    },
    beforeDestroy () {
      this.getSchema()
      this.$emit('change', this.value)
    },
    methods: {
      addField () {
        const key = (Math.random() * 1000000).toFixed(0)
        this.schemaTable.push({
          fieldName: 'newField',
          options: {},
          initialFrom: null,
          choices: [],
          required: true,
          visible: true,
          type: 'text',
          visibleIf: '',
          title: null,
          placeholder: null,
          messageOnError: null,
          autocapitalize: null,
          key
        })
        this.expandedRows.push(key)
      },
      handleDelete (e, index, row) {
        this.schemaTable.splice(index, 1)
      },
      getSchema () {
        {
          let newData = this.$refs.schemaTable.data
          let newRequired = newData.filter(r => r.required).map(e => e.fieldName)
          // Если не автосхема
          this.value.properties = this.schemaTable.reduce((obj, field, index) => {
            let result
            if (Object.keys(field.options).length > 0) {
              result = field.options
            } else {
              result = {}
            }

            result.attrs = result.attrs || {}

            result.attrs.type = field.type
            result.title = field.title
            result.visible = field.visible
            result.visibleIf = field.visibleIf
            result.attrs.placeholder = field.placeholder
            result.attrs.title = field.messageOnError
            result.attrs.autocapitalize = field.autocapitalize
            result.attrs.initialFrom = field.initialFrom

            switch (field.type) {
              case 'radiogroup':
                result.oneOf = field.choices
                break
              case 'select':
                result.enum = field.choices
                break
              case 'checkboxgroup':
                result.anyOf = field.choices
                break
            }

            // Определяем тип поля для схемы
            result.type = this.getSchemaFieldType(field.type)


            obj[field.fieldName] = result
            return obj
          }, {})
          this.value.required = newRequired
          return this.value
        }
      },
      getSchemaFieldType(name) {
        switch (name) {
          case 'text':
          case 'phone':
          case 'email':
          case 'date':
          case 'radiogroup':
            return 'string'
            break
          case 'select':
            return 'integer'
            break
          case 'checkbox':
          case 'switch':
            return 'boolean'
            break
          default:
            return 'array'
            break
        }
      },
      showChoices(row) {
        switch (row.type) {
          case 'radiogroup':
          case 'select':
          case 'checkboxgroup':
            return true
            break
        }
      },
      getSchemaTable (schema) {
        if (!schema || schema.properties === undefined) {
          return []
        }
        return Object.entries(schema.properties).map(e => {
          let fieldName = e[0]
          let options = e[1]

          let type = options.attrs.type || 'text'

          let choices = []
          switch (type) {
            case 'radiogroup':
              choices = options.oneOf || []
              break
            case 'select':
              choices = options.enum || []
              break
            case 'checkboxgroup':
              choices = options.anyOf || []
              break
          }

          // const key = (Math.random() * 1000000).toFixed(0)
          const key = fieldName

          return {
            key,
            fieldName,
            options,
            choices,
            initialFrom: options.attrs.initialFrom || null,
            required: schema.required.includes(e[0]),
            visible: options.visible !== undefined ? options.visible : true,
            type: type,
            visibleIf: options.visibleIf || '',
            title: options.title,
            placeholder: options.attrs.placeholder,
            messageOnError: options.attrs.title,
            autocapitalize: options.attrs.autocapitalize
          }
        })
      },
    }
  }
</script>

<style scoped>

</style>
